import "./AdditionalServices.css";
import TextField from "./TextField";
import InputAdornment from "@mui/material/InputAdornment";

// Material icon paths, drawn inline (the design's icons for this section).
const ICONS = {
  box: "M12 2 2 7v10l10 5 10-5V7L12 2zm0 2.2 6.9 3.4L12 11 5.1 7.6 12 4.2zM4 9.1l7 3.5v7.2l-7-3.5V9.1zm9 10.7v-7.2l7-3.5v7.2l-7 3.5z",
  pallet:
    "M3 16h18v2H3zm0 3h4v2H3zm14 0h4v2h-4zM5 4h6v6H5zm8 0h6v6h-6zM5 11h14v4H5z",
  check: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
  pen: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z",
  home: "M12 5.69 17 10.19V18h-2v-6H9v6H7v-7.81l5-4.5M12 3 2 12h3v8h6v-6h2v6h6v-8h3L12 3z",
  info: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z",
  shield:
    "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z",
  lift: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9 1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM9 7v3H6.5L10 13.5 13.5 10H11V7H9z",
};
const Icon = ({ name }) => (
  <svg
    className="shiptype__icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path d={ICONS[name]} />
  </svg>
);

export default function AdditionalServices(props) {
  const { List, SetList, StepCheck, SetStepCheck, Tlist, setTlist, Plist } =
    props;

  const handleStepper = () => {
    SetStepCheck((prevStepCheck) => ({
      ...prevStepCheck,
      Additional_services_bit: 0,
      QuoteCheck: false,
    }));
  };

  const handlechange = (e) => {
    const { name } = e.target;
    handleStepper();
    SetList({ ...List, [name]: !List[name] });
  };

  const handleinsurance = (e) => {
    const { name, value } = e.target;
    handleStepper();
    SetList({ ...List, [name]: value });
  };

  const handleinsurancetype = (type) => {
    SetStepCheck((prevStepCheck) => ({
      ...prevStepCheck,
      Additional_services_bit: 0,
      QuoteCheck: false,
      insurancetype: type,
    }));
  };

  const handleresidential = () => {
    SetStepCheck((prevStepCheck) => ({
      ...prevStepCheck,
      Delivery_Address_bit: 0,
      QuoteCheck: false,
    }));
    setTlist({ ...Tlist, residential: !Tlist["residential"] });
  };

  const handletype = (e) => {
    const { name } = e.target;
    SetStepCheck((prevStepCheck) => ({
      ...prevStepCheck,
      [name]: !StepCheck[name],
      QuoteCheck: false,
    }));
  };

  // Package and Pallet are independent switches, as before: one, both or
  // neither can be on. They choose which carriers are asked for rates
  // (shipping.services.js) and which services can be changed here.
  const isPackage = StepCheck["Package"] === true;
  const isPallet = StepCheck["Pallet"] === true;

  // Every service button the two cards had, in one row, enabled exactly when
  // before: the Package card's (Signature, Residential, Insurance) with
  // Package, the Pallet card's (Signature, Residential, Tailgate pickup,
  // Tailgate delivery) with Pallet. Signature and Residential were in both
  // cards and both copies changed the same value, so each is one chip, enabled
  // with either switch. A disabled chip keeps its value, and that value is
  // still sent (docs/MAP.md, AdditionalServices).
  const services = [
    {
      name: "signature",
      label: "Signature",
      icon: "pen",
      title: "Recipient signs on delivery",
      on: List["signature"],
      enabled: isPackage || isPallet,
      onClick: handlechange,
    },
    {
      name: "residential",
      label: "Residential",
      icon: "home",
      title: "Delivery to a home address",
      on: Tlist["residential"],
      enabled: isPackage || isPallet,
      onClick: handleresidential,
    },
    {
      name: "insurance",
      label: "Insurance",
      icon: "shield",
      title: "Cover the declared value (packages)",
      on: List["insurance"],
      enabled: isPackage,
      onClick: handlechange,
    },
    {
      name: "tailgatepickup",
      label: "Tailgate pickup",
      icon: "lift",
      title: "Liftgate truck at pickup (pallets)",
      on: List["tailgatepickup"],
      enabled: isPallet,
      onClick: handlechange,
    },
    {
      name: "tailgatedelivery",
      label: "Tailgate delivery",
      icon: "lift",
      title: "Liftgate truck at delivery (pallets)",
      on: List["tailgatedelivery"],
      enabled: isPallet,
      onClick: handlechange,
    },
  ];

  /* Not offered yet: these buttons were commented out in both cards and stay
     commented out. Redrawn here as chips for when they are switched on: add
     them to `services` above (they already have values in List, which are
     sent today), and move their icon paths into ICONS. In the Package card
     they were enabled with Package; in the Pallet card with Pallet, which
     also had its own Insurance button (commented out too).

  const ICONS_LATER = {
    returnlabel: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z",
    fragile: "M6 3v6c0 2.97 2.16 5.43 5 5.91V19H8v2h8v-2h-3v-4.09c2.84-.48 5-2.94 5-5.91V3H6zm10 5H8V5h8v3z",
    paperinvoice: "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z",
    dangerious: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
    appointment: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z",
    thirdpartybilling: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z",
    cashondelivery: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z",
  };

  const servicesLater = [
    { name: "returnlabel", label: "Return label", icon: "returnlabel", enabled: isPackage || isPallet, on: List["returnlabel"], onClick: handlechange },
    { name: "fragile", label: "Fragile goods", icon: "fragile", enabled: isPackage || isPallet, on: List["fragile"], onClick: handlechange },
    { name: "paperinvoice", label: "Paper invoice", icon: "paperinvoice", enabled: isPackage || isPallet, on: List["paperinvoice"], onClick: handlechange },
    { name: "dangerious", label: "Dangerous goods", icon: "dangerious", enabled: isPackage || isPallet, on: List["dangerious"], onClick: handlechange },
    { name: "appointment", label: "Appointment delivery", icon: "appointment", title: "If you want the carrier to book the appointment for delivery", enabled: isPackage || isPallet, on: List["appointment"], onClick: handlechange },
    { name: "thirdpartybilling", label: "Collect/Third party billing", icon: "thirdpartybilling", title: "If you want the reciver to pay for the shipment", enabled: isPackage || isPallet, on: List["thirdpartybilling"], onClick: handlechange },
    { name: "cashondelivery", label: "Cash on delivery", icon: "cashondelivery", enabled: isPackage || isPallet, on: List["cashondelivery"], onClick: handlechange },
    // Pallet card only: { name: "insurance", label: "Insurance", icon: "shield", enabled: isPallet, ... }
  ];
  */

  const selected = services
    .filter((s) => s.on)
    .map((s) => s.label.toLowerCase());
  const servicesHint =
    isPackage && isPallet
      ? "for packages and pallets"
      : isPackage
        ? "for packages"
        : isPallet
          ? "for pallets"
          : "";

  const typeTile = (name, label, sub, icon, on) => (
    <button
      type="button"
      id={name}
      name={name}
      role="checkbox"
      aria-checked={on}
      className="shiptype__tile"
      onClick={() => handletype({ target: { name } })}
    >
      <span className="shiptype__tile-ic">
        <Icon name={icon} />
      </span>
      <span className="shiptype__tile-txt">
        <b>{label}</b>
        {/* two halves that never break inside, so a narrow tile wraps at the dot */}
        <small>
          <span>{sub[0]}</span>
          {"\u00a0· "}
          <span>{sub[1]}</span>
        </small>
      </span>
      <span className="shiptype__check">
        <Icon name="check" />
      </span>
    </button>
  );

  return (
    <>
      <div className="service__card_box_ship_page main__service_card_wrap">
        <div
          className="card bg-ui-surface shadow wapper_like_shopify shiptype__card"
          data-ship-step="services"
        >
          <div className="card-body service__card_box_ship_body">
            {/* package__type_main_wrap stays: readability.css keys the Ship
                page's popup and menu sizes on it (body:has) and sizes the
                insurance field with it. */}
            <div className="package__type_main_wrap shiptype">
              <div className="shiptype__grid">
                <div className="shiptype__block">
                  <div className="shiptype__title" id="shiptypeTitle">
                    Shipment type{" "}
                    <span className="shiptype__hint">pick one or both</span>
                  </div>
                  <div
                    className="shiptype__tiles"
                    role="group"
                    aria-labelledby="shiptypeTitle"
                  >
                    {typeTile(
                      "Package",
                      "Package",
                      ["Boxes & parcels", "courier rates"],
                      "box",
                      isPackage,
                    )}
                    {typeTile(
                      "Pallet",
                      "Pallet",
                      ["Skids & freight", "LTL rates"],
                      "pallet",
                      isPallet,
                    )}
                  </div>
                  {isPackage && isPallet && (
                    <div className="shiptype__note">
                      Both on: courier and LTL carriers are asked for rates.
                    </div>
                  )}
                </div>

                <div className="shiptype__block">
                  <div className="shiptype__title" id="shiptypeServices">
                    Additional services{" "}
                    {servicesHint && (
                      <span className="shiptype__hint">{servicesHint}</span>
                    )}
                  </div>
                  <div
                    className="shiptype__chips"
                    role="group"
                    aria-labelledby="shiptypeServices"
                  >
                    {services.map((s) => (
                      <button
                        key={s.name}
                        type="button"
                        id={s.name}
                        name={s.name}
                        aria-pressed={!!s.on}
                        title={s.title}
                        className="shiptype__chip"
                        disabled={!s.enabled}
                        onClick={() => s.onClick({ target: { name: s.name } })}
                      >
                        <Icon name={s.icon} />
                        <span>{s.label}</span>
                        <span className="shiptype__check">
                          <Icon name="check" />
                        </span>
                      </button>
                    ))}
                    {/* The not-offered-yet services, commented out as before
                        (see servicesLater above). Same chip, shown disabled
                        with "Available soon", as the old buttons were:
                    {servicesLater.map((s) => (
                      <button
                        key={s.name}
                        type="button"
                        id={s.name}
                        name={s.name}
                        aria-pressed={!!s.on}
                        title={s.title || "Available soon"}
                        className="shiptype__chip"
                        disabled
                      >
                        <svg className="shiptype__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                          <path d={ICONS_LATER[s.icon]} />
                        </svg>
                        <span>{s.label}</span>
                        <span className="shiptype__check">
                          <Icon name="check" />
                        </span>
                      </button>
                    ))} */}
                  </div>

                  {/* Insurance type on one line. type="button" so a click only
                      changes the type and Enter in a field no longer presses
                      Per Package; both used to submit the form (KNOWN_ISSUES.md
                      SP-028, fixed). */}
                  {List["insurance"] === true && (
                    <div className="insurance_check_body_container shiptype__insurance">
                      <span className="font-semibold">Insurance type</span>
                      <div className="shiptype__seg">
                        <button
                          type="button"
                          onClick={() => handleinsurancetype("Package")}
                          aria-pressed={
                            StepCheck["insurancetype"] === "Package"
                          }
                          data-tip="Each package gets its own insured value"
                          className="shiptype__seg-btn"
                        >
                          Per Package
                        </button>
                        <button
                          type="button"
                          onClick={() => handleinsurancetype("Shipment")}
                          aria-pressed={
                            StepCheck["insurancetype"] === "Shipment"
                          }
                          data-tip="One insured value for the whole shipment"
                          className="shiptype__seg-btn"
                        >
                          Per Shipment
                        </button>
                      </div>

                      {StepCheck["insurancetype"] === "Package" && (
                        <span className="shiptype__ins-note">
                          <Icon name="info" />
                          Enter a value on each package below
                        </span>
                      )}

                      <div className="insurance__field_perShipment">
                        {StepCheck["insurancetype"] === "Shipment" && (
                          <>
                            <TextField
                              className="insurance__field_perShipment_input"
                              Label="Insured value"
                              Type="number"
                              Name="insurancevalue"
                              PlaceHolder="Insured value"
                              Data={List["insurancevalue"]}
                              Handler={(e) => handleinsurance(e)}
                              SX={{
                                width: "30%",
                                input: { font: "menu" },
                                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                  {
                                    display: "none",
                                  },
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment
                                    position="start"
                                    sx={{ color: "var(--color-brand)" }}
                                  >
                                    <b>
                                      <small>$</small>
                                    </b>
                                  </InputAdornment>
                                ),
                              }}
                            />
                            <span className="shiptype__ins-note">
                              for the whole shipment
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {/* The Pallet card's older insurance-type picker ("P" / "S"
                      with tooltips), commented out as before. Redrawn in the
                      chip style; it would set the same insurancetype as the
                      Per Package / Per Shipment buttons above:
                  {List["insurance"] === true && (
                    <div className="shiptype__chips" role="group" aria-label="Insurance type">
                      <button
                        type="button"
                        title="P means Per Package"
                        aria-pressed={StepCheck["insurancetype"] === "Package"}
                        className="shiptype__chip"
                        onClick={() => handleinsurancetype("Package")}
                      >
                        <span>P</span>
                      </button>
                      <button
                        type="button"
                        title="S means Per Shipment"
                        aria-pressed={StepCheck["insurancetype"] === "Shipment"}
                        className="shiptype__chip"
                        onClick={() => handleinsurancetype("Shipment")}
                      >
                        <span>S</span>
                      </button>
                    </div>
                  )} */}

                  <div className="shiptype__foot">
                    {!isPackage && !isPallet
                      ? "Pick Package or Pallet to choose services."
                      : selected.length
                        ? `Selected: ${selected.join(", ")} — surcharges are itemized in each quote.`
                        : "No extras selected — surcharges are itemized in each quote."}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
